import Timings from '@dynatrace/strato-design-tokens/timings-js';

import { ZoomChangeType } from '../../../../../core/types/zoom.js';

const PLUS_MINUS_DURATION = Timings.Base.Quick * 1000;
const RESET_DURATION = Timings.Base.Default * 1000;

/**
 *
 * @param zoomBehavior -
 * @returns
 */
export function getDuration(
  zoomBehavior: ZoomChangeType | undefined,
): number | undefined {
  return zoomBehavior
    ? zoomBehavior === 'reset'
      ? RESET_DURATION
      : PLUS_MINUS_DURATION
    : undefined;
}
